export default __webpack_public_path__ + "00473188c8673fe526367565986dceda.bin";